import { render, staticRenderFns } from "./ModalWithdrawWithPixError.vue?vue&type=template&id=7b73b504&"
import script from "./ModalWithdrawWithPixError.vue?vue&type=script&lang=js&"
export * from "./ModalWithdrawWithPixError.vue?vue&type=script&lang=js&"
import style0 from "./ModalWithdrawWithPixError.vue?vue&type=style&index=0&id=7b73b504&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports